/**
 * 题目 api
 * 题目 api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import ActorVo from './ActorVo';
import DialogueItemVo from './DialogueItemVo';




  /**
   * The DialogueDrillVo model module.
   * @module drill/model/DialogueDrillVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>DialogueDrillVo</code>.
   * @alias module:drill/model/DialogueDrillVo
   * @class
   * @param subType {Integer} 401：对话；402：模拟通话 403：课文录音
   * @param required {Boolean} 必做
   * @param actorList {Array.<module:drill/model/ActorVo>} 角色列表
   * @param dialogueItems {Array.<module:drill/model/DialogueItemVo>} 对话项
   */
  var exports = function(subType, required, actorList, dialogueItems) {
    var _this = this;


    _this['subType'] = subType;
    _this['required'] = required;






    _this['actorList'] = actorList;
    _this['dialogueItems'] = dialogueItems;
  };

  /**
   * Constructs a <code>DialogueDrillVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:drill/model/DialogueDrillVo} obj Optional instance to populate.
   * @return {module:drill/model/DialogueDrillVo} The populated <code>DialogueDrillVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'subType')) {
        obj['subType'] = ApiClient.convertToType(data['subType'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'required')) {
        obj['required'] = ApiClient.convertToType(data['required'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'text')) {
        obj['text'] = ApiClient.convertToType(data['text'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'explanation')) {
        obj['explanation'] = ApiClient.convertToType(data['explanation'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'videoUri')) {
        obj['videoUri'] = ApiClient.convertToType(data['videoUri'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'audioUri')) {
        obj['audioUri'] = ApiClient.convertToType(data['audioUri'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'thumbUri')) {
        obj['thumbUri'] = ApiClient.convertToType(data['thumbUri'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'basicData')) {
        obj['basicData'] = ApiClient.convertToType(data['basicData'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'actorList')) {
        obj['actorList'] = ApiClient.convertToType(data['actorList'], [ActorVo]);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'dialogueItems')) {
        obj['dialogueItems'] = ApiClient.convertToType(data['dialogueItems'], [DialogueItemVo]);
      }
    }
    return obj;
  }

  /**
   * id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 401：对话；402：模拟通话 403：课文录音
   * @member {Integer} subType
   */
  exports.prototype['subType'] = undefined;
  /**
   * 必做
   * @member {Boolean} required
   */
  exports.prototype['required'] = undefined;
  /**
   * 文本
   * @member {String} text
   */
  exports.prototype['text'] = undefined;
  /**
   * 解析
   * @member {String} explanation
   */
  exports.prototype['explanation'] = undefined;
  /**
   * 对话视频地址
   * @member {String} videoUri
   */
  exports.prototype['videoUri'] = undefined;
  /**
   * 对话音频地址
   * @member {String} audioUri
   */
  exports.prototype['audioUri'] = undefined;
  /**
   * 封面图片地址
   * @member {String} thumbUri
   */
  exports.prototype['thumbUri'] = undefined;
  /**
   * 对话背景
   * @member {String} basicData
   */
  exports.prototype['basicData'] = undefined;
  /**
   * 角色列表
   * @member {Array.<module:drill/model/ActorVo>} actorList
   */
  exports.prototype['actorList'] = undefined;
  /**
   * 对话项
   * @member {Array.<module:drill/model/DialogueItemVo>} dialogueItems
   */
  exports.prototype['dialogueItems'] = undefined;



  export default exports;
;


